<template>
  <div>
    <el-card>
      <el-button type="primary" @click="add">新增模板</el-button>
    </el-card>
    <el-card>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="templateName" label="模板名称">
        </el-table-column>
        <el-table-column prop="deptName" label="科室">
        </el-table-column>
        <el-table-column prop="docName" label="医生名称"> </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="formatUnix"
        >
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="success"
              @click.prevent="getDetails(scope.row)"
              >详情
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click.prevent="edit(scope.row)"
              >编辑
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click.prevent="deleteMedical(scope.row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row
        class="pagination-wrapper"
        type="flex"
        justify="end"
        style="margin-top: 30px"
      >
        <el-pagination
          layout="total,sizes,prev, pager, next"
          @size-change="handleSizeChange"
          :current-page.sync="page.pageNum"
          @current-change="onCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :total="page.total"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { formatUnixTime } from "../../utils/DateFormat.js";
export default {
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
      },
      tableData: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    getDetails(row) {
      this.$router.push({
        path: "/main/addMedicalTemplate",
        query: { id: row.id,detail:true },
      });
    },
    edit(row) {
      this.$router.push({
        path: "/main/addMedicalTemplate",
        query: { id: row.id,},
      });
    },
    async deleteMedical(row) {
      let that = this;
      const options = {
        templateId: row.id,
        token: localStorage.getItem("token"),
      };
      let { code, obj } = await this.$http(
        "smarthos.user.book.case.history.template.delete",
        options
      );
      if (code == "0") {
        that.$message.success("删除成功");
        that.initData();
      }
    },
    formatUnix: function (row, column) {
      //格式化时间格式
      return formatUnixTime(row.createTime, "yyyy-MM-dd HH:mm");
    },
    add() {
      this.$router.push({
        path: "/main/addMedicalTemplate",
        // query: { id: item.visitid },
      });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.initData();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.initData();
    },
    async initData() {
      let that = this;
      const options = {
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        pageNum: that.page.pageNum,
        pageSize: that.page.pageSize,
        token: localStorage.getItem("token"),
      };
      let { code, obj } = await this.$http(
        "smarthos.user.book.case.history.template.list",
        options
      );
      if (code == "0") {
        that.page.total = obj.amout;
        if (obj.userBookCaseHistoryTemplateList) {
          that.tableData = obj.userBookCaseHistoryTemplateList;
        }else{
          that.tableData=[];
        }
      }
    },
  },
};
</script>
<style scoped>
</style>